import axios from 'axios'
import { showFailToast } from 'vant'
import { getToken } from '@/utils/authUtils';
import { getCurrentCompanyId } from '@/utils/company';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 10000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加请求头等前置处理
    config.headers['Authorization'] = 'Bearer' + ' ' + getToken()
    config.headers['clientid'] = 'bc84e6c82e5f4bea008575701fd32ea5'
    // H5 只支持具体公司切换，不提供“全部公司”模式
    config.headers['X-Company-Id'] = getCurrentCompanyId()
    return config
  },
  () => {
    showFailToast('系统异常,请稍后再试')
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 响应后处理
    if (response.status === 200 && response.data.code === 200) {
      if (response.data.data) {
        return Promise.resolve(response.data.data)
      } else {
        return Promise.resolve(response.data.rows)
      }
    } else {
      const res = response.data || {}
      // 带附加数据（如排课冲突详情列表）的错误，不在此弹 toast，交给页面展示，与 PC 端行为一致
      if (res.data && Array.isArray(res.data) && res.data.length > 0) {
        return Promise.reject(Object.assign({}, res, { message: res.msg || '请求失败' }))
      }
      if (!response.config.silent) {
        showFailToast(res.msg || '请求失败')
      }
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
  },
  error => {
    if (!error?.config?.silent) {
      showFailToast(error?.message || '网络异常，请稍后再试')
    }
    return Promise.reject(error)
  }
)

export default service
